function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, DEFAULTS, AbstractConfigurablePlugin, events as events_exports$1, TypedEvent, AbstractComponent, SYSTEM, CONSTANTS as constants_exports } from '../core/index.module.js';
import { MathUtils } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.MapPlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  SelectHotspot: function SelectHotspot() {
    return _SelectHotspot2;
  }
});
var _SelectHotspot = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_SelectHotspot, _TypedEvent);
  var _super = _createSuper(_SelectHotspot);
  function _SelectHotspot(hotspotId) {
    var _this;
    _classCallCheck(this, _SelectHotspot);
    _this = _super.call(this, _SelectHotspot.type);
    _this.hotspotId = hotspotId;
    return _this;
  }
  return _createClass(_SelectHotspot);
}(TypedEvent);
var _SelectHotspot2 = _SelectHotspot;
_SelectHotspot2.type = "select-hotspot";

// src/constants.ts
var MARKER_DATA_KEY = "map";
var HOTSPOT_GENERATED_ID = "__generated__";
var HOTSPOT_MARKER_ID = "__marker__";
var PIN_SHADOW_OFFSET = 2;
var PIN_SHADOW_BLUR = 4;
var MAP_SHADOW_BLUR = 10;
function loadImage(src) {
  var image = document.createElement("img");
  if (!src.includes("<svg")) {
    image.src = src;
  } else {
    if (!/<svg[^>]*width="/.test(src) && src.includes("viewBox")) {
      var _exec = /viewBox="([0-9-]+) ([0-9-]+) ([0-9]+) ([0-9]+)"/.exec(src),
        _exec2 = _slicedToArray(_exec, 5),
        width = _exec2[3],
        height = _exec2[4];
      src = src.replace("<svg", "<svg width=\"".concat(width, "px\" height=\"").concat(height, "px\""));
    }
    var src64 = "data:image/svg+xml;base64,".concat(window.btoa(src));
    image.src = src64;
  }
  return image;
}
function getImageHtml(src) {
  if (!src) {
    return "";
  } else if (!src.includes("<svg")) {
    return "<img src=\"".concat(src, "\">");
  } else {
    return src;
  }
}
function unprojectPoint(pt, yaw, zoom) {
  return {
    x: (Math.cos(yaw) * pt.x - Math.sin(yaw) * pt.y) / zoom,
    y: (Math.sin(yaw) * pt.x + Math.cos(yaw) * pt.y) / zoom
  };
}
function projectPoint(pt, yaw, zoom) {
  return {
    x: (Math.cos(-yaw) * pt.x - Math.sin(-yaw) * pt.y) * zoom,
    y: (Math.sin(-yaw) * pt.x + Math.cos(-yaw) * pt.y) * zoom
  };
}
function canvasShadow(context, offsetX, offsetY, blur) {
  var color = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "black";
  context.shadowOffsetX = offsetX * SYSTEM.pixelRatio;
  context.shadowOffsetY = offsetY * SYSTEM.pixelRatio;
  context.shadowBlur = blur * SYSTEM.pixelRatio;
  context.shadowColor = color;
}
function drawImageCentered(context, image, size) {
  var w = image.width;
  var h = image.height;
  drawImageHighDpi(context, image, -size / 2, -(h / w * size) / 2, size, h / w * size);
}
function drawImageHighDpi(context, image, x, y, w, h) {
  context.drawImage(image, 0, 0, image.width, image.height, x * SYSTEM.pixelRatio, y * SYSTEM.pixelRatio, w * SYSTEM.pixelRatio, h * SYSTEM.pixelRatio);
}

// src/icons/map.svg
var map_default = '<svg viewBox="114 45 472 472" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M383.6 196a67.3 67.3 0 1 0-134.5.1 67.3 67.3 0 0 0 134.5-.1zm-100.8 0a33.6 33.6 0 1 1 67.3 0 33.6 33.6 0 0 1-67.3 0z"/><path d="M584 340.8a16.8 16.8 0 0 0-15.6-10.4H403.8c25.2-40.2 47-88 47-133.4A135 135 0 0 0 316.4 61.6 135 135 0 0 0 182 197c0 55.8 33 115.3 64.7 159.8L120.4 469a16.8 16.8 0 0 0 11.2 29.4H434c4.5 0 8.7-1.8 11.9-5l134.4-134.3c4.8-4.8 6.2-12 3.6-18.3zM215.5 197c0-56.1 45.2-101.8 100.8-101.8 55.6 0 100.8 45.6 100.8 101.8 0 65-57.1 144.2-100.8 192.8C273 341.7 215.6 262.3 215.6 197zM427 464.8H175.8l91.3-81.1a575.6 575.6 0 0 0 37.4 42.6 16.8 16.8 0 0 0 23.8 0c2.2-2.2 26.3-26.7 52.6-62.3h147z"/></g><!-- Created by Ayub Irawan from Noun Project --></svg>';
var INVERT_POSITIONS = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function getButtonPosition(mapPosition, direction) {
  switch (direction) {
    case 1 /* DIAGONAL */:
      return [INVERT_POSITIONS[mapPosition[0]], INVERT_POSITIONS[mapPosition[1]]];
    case 2 /* HORIZONTAL */:
      return [mapPosition[0], INVERT_POSITIONS[mapPosition[1]]];
    case 3 /* VERTICAL */:
      return [INVERT_POSITIONS[mapPosition[0]], mapPosition[1]];
    default:
      return mapPosition;
  }
}
var AbstractMapButton = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(AbstractMapButton, _AbstractComponent);
  var _super2 = _createSuper(AbstractMapButton);
  function AbstractMapButton(map, position) {
    var _this2;
    _classCallCheck(this, AbstractMapButton);
    _this2 = _super2.call(this, map, {});
    _this2.map = map;
    _this2.position = position;
    return _this2;
  }
  _createClass(AbstractMapButton, [{
    key: "applyConfig",
    value: function applyConfig() {
      this.container.className = "psv-map__button psv-map__button--".concat(getButtonPosition(this.map.config.position, this.position).join("-"));
      this.update();
    }
  }, {
    key: "update",
    value: function update() {}
  }]);
  return AbstractMapButton;
}(AbstractComponent);

// src/components/MapCloseButton.ts
var MapCloseButton = /*#__PURE__*/function (_AbstractMapButton) {
  _inherits(MapCloseButton, _AbstractMapButton);
  var _super3 = _createSuper(MapCloseButton);
  function MapCloseButton(map) {
    var _this3;
    _classCallCheck(this, MapCloseButton);
    _this3 = _super3.call(this, map, 0 /* DEFAULT */);
    _this3.container.addEventListener("click", function (e) {
      map.toggleCollapse();
      e.stopPropagation();
    });
    return _this3;
  }
  _createClass(MapCloseButton, [{
    key: "applyConfig",
    value: function applyConfig() {
      _get(_getPrototypeOf(MapCloseButton.prototype), "applyConfig", this).call(this);
      this.container.classList.add("psv-map__button-close");
    }
  }, {
    key: "update",
    value: function update() {
      this.container.innerHTML = this.map.collapsed ? map_default : constants_exports.ICONS.close;
      this.container.title = this.map.collapsed ? this.viewer.config.lang["map"] : this.viewer.config.lang.close;
    }
  }]);
  return MapCloseButton;
}(AbstractMapButton);

// src/icons/maximize.svg
var maximize_default = '<svg viewBox="95 25 510 510" xmlns="http://www.w3.org/2000/svg"><path d="M604.2 39.8v481c0 7.8-6.1 14-14 14H358.4c-7.8 0-14-6.2-14-14s6.2-14 14-14h217.8v-453H123.8v216.7c0 7.8-6.2 14-14 14-7.9 0-14-6.2-14-14V39.8c0-7.9 6.1-14 14-14h481c7.3 0 13.4 6.1 13.4 14zm-304 304v176.4c0 7.9-6.2 14-14 14H109.8c-7.9 0-14-6.1-14-14V343.8c0-7.8 6.1-14 14-14h176.4c7.2 0 14 6.8 14 14zm-28 14H123.8v148.4h148.4zm215.6-195.4v79.5c0 7.9 6.1 14 14 14 7.8 0 14-6.1 14-14V128.2c0-7.8-6.2-14-14-14H388.6c-7.8 0-14 6.2-14 14 0 7.9 6.2 14 14 14h79L326.5 283.4a13.5 13.5 0 0 0 0 19.6c2.8 2.8 6.1 3.9 10 3.9 4 0 7.3-1.1 10.1-4z" fill="currentColor"/><!-- Created by Gregor Cresnar from Noun Project --></svg>';

// src/icons/minimize.svg
var minimize_default = '<svg viewBox="95 25 510 510" xmlns="http://www.w3.org/2000/svg"><path d="M109.8 25.8h481c7.8 0 14 6.1 14 14v481c0 7.8-6.2 14-14 14H358.4c-7.8 0-14-6.2-14-14s6.2-14 14-14h217.8v-453H123.8v216.7c0 7.8-6.2 14-14 14-7.9 0-14-6.2-14-14V39.8c0-7.9 6.1-14 14-14zm176.4 508.4H109.8c-7.9 0-14-6.1-14-14V343.8c0-7.8 6.1-14 14-14h176.4c7.8 0 14 6.2 14 14v176.4c0 7.9-6.8 14-14 14zm-14-176.4H123.8v148.4h148.4zm64.4-191.5c-7.9 0-14 6.2-14 14v113.1c0 7.9 6.1 14 14 14h113c8 0 14-6.1 14-14s-6-14-14-14h-79.4l141-141a13.5 13.5 0 0 0 0-19.7 13.5 13.5 0 0 0-19.5 0L350.6 259.8v-79.5c0-7.8-6.2-14-14-14z" fill="currentColor"/><!-- Created by Gregor Cresnar from Noun Project --></svg>';

// src/components/MapMaximizeButton.ts
var ROTATION = {
  "bottom-left": 0,
  "bottom-right": -90,
  "top-right": 180,
  "top-left": 90
};
var MapMaximizeButton = /*#__PURE__*/function (_AbstractMapButton2) {
  _inherits(MapMaximizeButton, _AbstractMapButton2);
  var _super4 = _createSuper(MapMaximizeButton);
  function MapMaximizeButton(map) {
    var _this4;
    _classCallCheck(this, MapMaximizeButton);
    _this4 = _super4.call(this, map, 1 /* DIAGONAL */);
    _this4.container.addEventListener("click", function (e) {
      map.toggleMaximized();
      e.stopPropagation();
    });
    return _this4;
  }
  _createClass(MapMaximizeButton, [{
    key: "update",
    value: function update() {
      this.container.innerHTML = this.map.maximized ? minimize_default : maximize_default;
      this.container.querySelector("svg").style.transform = "rotate3d(0, 0, 1, ".concat(ROTATION[this.map.config.position.join("-")], "deg)");
      this.container.title = this.map.maximized ? this.viewer.config.lang["mapMinimize"] : this.viewer.config.lang["mapMaximize"];
    }
  }]);
  return MapMaximizeButton;
}(AbstractMapButton);

// src/icons/reset.svg
var reset_default = '<svg viewBox="170 100 360 360" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M518.6 269h-18.5a150.8 150.8 0 0 0-138-137.9v-20.9c0-5.8-4.7-10.6-10.5-10.6h-3.2c-5.8 0-10.6 4.8-10.6 10.6v21A150.8 150.8 0 0 0 200 269h-18.5c-5.9 0-10.6 4.7-10.6 10.6v3.2c0 5.8 4.7 10.5 10.6 10.5h18.5c6 73.4 64.6 132 138 138v18.5c0 5.8 4.7 10.6 10.5 10.6h3.2c5.8 0 10.6-4.8 10.6-10.6v-18.6c73.3-5.9 132-64.5 137.9-137.9h18.5c5.9 0 10.6-4.7 10.6-10.5v-3.2c0-5.9-4.7-10.6-10.6-10.6zM362.2 414.4v-9.8c0-5.9-4.8-10.6-10.6-10.6h-3.2c-5.8 0-10.6 4.7-10.6 10.6v9.8a134 134 0 0 1-121-121h9.8c5.9 0 10.6-4.8 10.6-10.6v-3.2c0-5.9-4.7-10.6-10.6-10.6h-9.8a134 134 0 0 1 121-121v7.5c0 5.8 4.8 10.5 10.6 10.5h3.2c5.8 0 10.6-4.7 10.6-10.5V148a134 134 0 0 1 121 121h-9.8c-5.9 0-10.6 4.7-10.6 10.6v3.2c0 5.8 4.7 10.5 10.6 10.5h9.8a134 134 0 0 1-121 121z"/><path d="M355.4 222a6 6 0 0 0-10.7 0L291 320a8.3 8.3 0 0 0 9.7 12l39.2-11.7c6.6-2 13.6-2 20.2 0l39.2 11.7a8.3 8.3 0 0 0 9.7-12z"/></g><!-- Created by muhammad benani from Noun Project --></svg>';

// src/components/MapResetButton.ts
var MapResetButton = /*#__PURE__*/function (_AbstractMapButton3) {
  _inherits(MapResetButton, _AbstractMapButton3);
  var _super5 = _createSuper(MapResetButton);
  function MapResetButton(map) {
    var _this5;
    _classCallCheck(this, MapResetButton);
    _this5 = _super5.call(this, map, 2 /* HORIZONTAL */);
    _this5.container.title = _this5.viewer.config.lang["mapReset"];
    _this5.container.innerHTML = reset_default;
    _this5.container.querySelector("svg").style.width = "80%";
    _this5.container.addEventListener("click", function (e) {
      map.reset();
      e.stopPropagation();
    });
    return _this5;
  }
  return _createClass(MapResetButton);
}(AbstractMapButton);

// src/icons/minus.svg
var minus_default = '<svg viewBox="128 58 444 444" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M350 58.2a221.8 221.8 0 1 0 0 443.6 221.8 221.8 0 0 0 0-443.6zm130.3 252.7H219.7a31 31 0 1 1 0-61.8h260.6a31 31 0 1 1 0 61.8z"/><!-- Created by Iconika from Noun Project --></svg>';

// src/icons/plus.svg
var plus_default = '<svg viewBox="143.8 73.8 412.5 412.5" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M350 73.8a206.2 206.2 0 1 0 0 412.4 206.2 206.2 0 0 0 0-412.4zm117.3 234H378v89.5a27.9 27.9 0 1 1-55.8 0V308h-89.4a27.9 27.9 0 1 1 0-55.8H322v-89.5a27.9 27.9 0 1 1 55.8 0v89.5h89.5a27.9 27.9 0 1 1 0 55.8z"/><!-- Created by Iconika from Noun Project --></svg>';

// src/components/MapZoomToolbar.ts
var MapZoomToolbar = /*#__PURE__*/function (_AbstractComponent2) {
  _inherits(MapZoomToolbar, _AbstractComponent2);
  var _super6 = _createSuper(MapZoomToolbar);
  function MapZoomToolbar(map) {
    var _this6;
    _classCallCheck(this, MapZoomToolbar);
    _this6 = _super6.call(this, map, {
      className: "psv-map__toolbar"
    });
    _this6.map = map;
    _this6.handler = new utils_exports.PressHandler(100);
    _this6.container.innerHTML = "".concat(minus_default, "<span class=\"psv-map__toolbar-text\">100%</span>").concat(plus_default);
    _this6.zoomIndicator = _this6.container.querySelector(".psv-map__toolbar-text");
    var zoomButtons = _this6.container.querySelectorAll("svg");
    zoomButtons[0].dataset["delta"] = "-1";
    zoomButtons[1].dataset["delta"] = "1";
    _this6.container.addEventListener("mousedown", _assertThisInitialized(_this6));
    window.addEventListener("mouseup", _assertThisInitialized(_this6));
    _this6.container.addEventListener("touchstart", _assertThisInitialized(_this6));
    window.addEventListener("touchend", _assertThisInitialized(_this6));
    return _this6;
  }
  _createClass(MapZoomToolbar, [{
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("mouseup", this);
      window.removeEventListener("touchend", this);
      _get(_getPrototypeOf(MapZoomToolbar.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var _this7 = this;
      switch (e.type) {
        case "mousedown":
        case "touchstart":
          {
            var button = utils_exports.getClosest(e.target, "svg");
            var delta = button === null || button === void 0 ? void 0 : button.dataset["delta"];
            if (delta) {
              cancelAnimationFrame(this.animation);
              this.handler.down();
              this.time = performance.now();
              this.animateZoom(parseInt(delta, 10));
              e.preventDefault();
              e.stopPropagation();
            }
            break;
          }
        case "mouseup":
        case "touchend":
          if (this.animation) {
            this.handler.up(function () {
              cancelAnimationFrame(_this7.animation);
              _this7.animation = null;
            });
            e.preventDefault();
            e.stopPropagation();
          }
          break;
      }
    }
  }, {
    key: "setText",
    value: function setText(zoom) {
      this.zoomIndicator.innerText = "".concat(Math.round(zoom * 100), "%");
    }
  }, {
    key: "animateZoom",
    value: function animateZoom(delta) {
      var _this8 = this;
      this.animation = requestAnimationFrame(function (t) {
        _this8.map.zoom(delta * (t - _this8.time) / 1e3);
        _this8.time = t;
        _this8.animateZoom(delta);
      });
    }
  }]);
  return MapZoomToolbar;
}(AbstractComponent);

// src/components/MapComponent.ts
var MapComponent = /*#__PURE__*/function (_AbstractComponent3) {
  _inherits(MapComponent, _AbstractComponent3);
  var _super7 = _createSuper(MapComponent);
  function MapComponent(viewer, plugin) {
    var _this9;
    _classCallCheck(this, MapComponent);
    _this9 = _super7.call(this, viewer, {});
    _this9.plugin = plugin;
    _this9.state = {
      visible: false,
      maximized: false,
      collapsed: false,
      zoom: _this9.config.defaultZoom,
      offset: {
        x: 0,
        y: 0
      },
      mouseX: null,
      mouseY: null,
      mousedown: false,
      pinchDist: 0,
      pinchAngle: 0,
      hotspotPos: {},
      hotspotId: null,
      hotspotTooltip: null,
      markers: [],
      forceRender: false,
      needsUpdate: false,
      renderLoop: null,
      images: {}
    };
    var canvasContainer = document.createElement("div");
    canvasContainer.className = "psv-map__container";
    canvasContainer.addEventListener("mousedown", _assertThisInitialized(_this9));
    window.addEventListener("mousemove", _assertThisInitialized(_this9));
    window.addEventListener("mouseup", _assertThisInitialized(_this9));
    canvasContainer.addEventListener("touchstart", _assertThisInitialized(_this9));
    window.addEventListener("touchmove", _assertThisInitialized(_this9));
    window.addEventListener("touchend", _assertThisInitialized(_this9));
    canvasContainer.addEventListener("wheel", _assertThisInitialized(_this9));
    _this9.canvas = document.createElement("canvas");
    canvasContainer.appendChild(_this9.canvas);
    _this9.compass = document.createElement("div");
    _this9.compass.className = "psv-map__compass";
    canvasContainer.appendChild(_this9.compass);
    _this9.container.appendChild(canvasContainer);
    _this9.container.addEventListener("transitionstart", _assertThisInitialized(_this9));
    _this9.container.addEventListener("transitionend", _assertThisInitialized(_this9));
    _this9.resetButton = new MapResetButton(_assertThisInitialized(_this9));
    _this9.maximizeButton = new MapMaximizeButton(_assertThisInitialized(_this9));
    _this9.closeButton = new MapCloseButton(_assertThisInitialized(_this9));
    _this9.zoomToolbar = new MapZoomToolbar(_assertThisInitialized(_this9));
    var renderLoop = function renderLoop() {
      if (_this9.isVisible() && (_this9.state.needsUpdate || _this9.state.forceRender)) {
        _this9.render();
        _this9.state.needsUpdate = false;
      }
      _this9.state.renderLoop = requestAnimationFrame(renderLoop);
    };
    renderLoop();
    _this9.applyConfig();
    _this9.hide();
    if (!_this9.config.visibleOnLoad) {
      _this9.toggleCollapse();
    }
    return _this9;
  }
  _createClass(MapComponent, [{
    key: "config",
    get: function get() {
      return this.plugin.config;
    }
  }, {
    key: "maximized",
    get: function get() {
      return this.state.maximized;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this.state.collapsed;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("touchmove", this);
      window.removeEventListener("mousemove", this);
      window.removeEventListener("touchend", this);
      window.removeEventListener("mouseup", this);
      cancelAnimationFrame(this.state.renderLoop);
      _get(_getPrototypeOf(MapComponent.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          {
            var event = e;
            this.state.mouseX = event.clientX;
            this.state.mouseY = event.clientY;
            this.state.mousedown = true;
            e.stopPropagation();
            break;
          }
        case "touchstart":
          {
            var _event = e;
            if (_event.touches.length === 1) {
              this.state.mouseX = _event.touches[0].clientX;
              this.state.mouseY = _event.touches[0].clientY;
              this.state.mousedown = true;
            } else if (_event.touches.length === 2) {
              var _utils_exports$getTou = utils_exports.getTouchData(_event);
              this.state.pinchDist = _utils_exports$getTou.distance;
              this.state.pinchAngle = _utils_exports$getTou.angle;
              var _utils_exports$getTou2 = _utils_exports$getTou.center;
              this.state.mouseX = _utils_exports$getTou2.x;
              this.state.mouseY = _utils_exports$getTou2.y;
            }
            e.stopPropagation();
            e.preventDefault();
            break;
          }
        case "mousemove":
          {
            var _event2 = e;
            if (this.state.mousedown) {
              this.__move(_event2.clientX, _event2.clientY);
              e.stopPropagation();
            } else {
              this.__handleHotspots(_event2.clientX, _event2.clientY);
            }
            break;
          }
        case "touchmove":
          {
            var _event3 = e;
            if (this.state.mousedown && _event3.touches.length === 1) {
              this.__move(_event3.touches[0].clientX, _event3.touches[0].clientY);
              e.stopPropagation();
            } else if (this.state.mousedown && _event3.touches.length === 2) {
              var touchData = utils_exports.getTouchData(_event3);
              var delta = (touchData.distance - this.state.pinchDist) / SYSTEM.pixelRatio;
              this.zoom(delta / 100);
              this.__move(touchData.center.x, touchData.center.y);
              if (this.state.maximized && !this.config["static"]) {
                this.viewer.dynamics.position.step({
                  yaw: this.state.pinchAngle - touchData.angle
                }, 0);
              }
              this.state.pinchDist = touchData.distance;
              this.state.pinchAngle = touchData.angle;
              e.stopPropagation();
            }
            break;
          }
        case "mouseup":
        case "touchend":
          {
            var _e$changedTouches;
            var mouse = ((_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches[0]) || e;
            if (this.state.mousedown) {
              this.state.mousedown = false;
              e.stopPropagation();
            }
            this.__clickHotspot(mouse.clientX, mouse.clientY);
            break;
          }
        case "wheel":
          {
            var _event4 = e;
            var _delta = _event4.deltaY / Math.abs(_event4.deltaY);
            this.zoom(-_delta / 10);
            e.stopPropagation();
            e.preventDefault();
            break;
          }
        case "transitionstart":
          this.state.forceRender = true;
          break;
        case "transitionend":
          if (!this.state.maximized && this.compass) {
            this.compass.style.display = "";
          }
          this.state.forceRender = false;
          this.update();
          break;
      }
    }
  }, {
    key: "applyConfig",
    value: function applyConfig() {
      this.container.className = "psv-map psv-map--".concat(this.config.position.join("-"), " psv--capture-event");
      this.container.style.width = this.config.size;
      this.container.style.height = this.config.size;
      this.compass.innerHTML = getImageHtml(this.config.compassImage);
      this.resetButton.applyConfig();
      this.closeButton.applyConfig();
      this.maximizeButton.applyConfig();
      this.update();
    }
  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(MapComponent.prototype), "show", this).call(this);
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      this.state.needsUpdate = true;
    }
  }, {
    key: "reload",
    value: function reload() {
      delete this.state.images[this.config.imageUrl];
      this.recenter();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.state.zoom = this.config.defaultZoom;
      this.recenter();
    }
  }, {
    key: "recenter",
    value: function recenter() {
      this.state.offset.x = 0;
      this.state.offset.y = 0;
      this.update();
    }
  }, {
    key: "toggleCollapse",
    value: function toggleCollapse() {
      if (this.state.maximized) {
        this.toggleMaximized();
      }
      this.state.collapsed = !this.state.collapsed;
      utils_exports.toggleClass(this.container, "psv-map--collapsed", this.state.collapsed);
      if (!this.state.collapsed) {
        this.reset();
      }
      this.closeButton.update();
    }
  }, {
    key: "toggleMaximized",
    value: function toggleMaximized() {
      if (this.state.collapsed) {
        return;
      }
      this.state.maximized = !this.state.maximized;
      utils_exports.toggleClass(this.container, "psv-map--maximized", this.state.maximized);
      if (this.state.maximized && this.compass) {
        this.compass.style.display = "none";
      }
      this.maximizeButton.update();
    }
  }, {
    key: "zoom",
    value: function zoom(d) {
      this.state.zoom = MathUtils.clamp(this.state.zoom + d, this.config.minZoom, this.config.maxZoom);
      this.update();
    }
  }, {
    key: "setMarkers",
    value: function setMarkers(markers) {
      this.state.markers = markers;
      this.update();
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;
      var mapImage = this.__loadImage(this.config.imageUrl);
      if (!mapImage) {
        return;
      }
      this.state.hotspotPos = {};
      this.__resetHotspot();
      var yaw = this.viewer.getPosition().yaw;
      var zoom = Math.exp(this.state.zoom);
      var center = this.config.center;
      var offset = this.state.offset;
      var rotation = this.config.rotation;
      var yawAndRotation = this.config["static"] ? 0 : yaw + rotation;
      if (this.compass && !this.config["static"]) {
        this.compass.style.transform = "rotate(".concat(-MathUtils.radToDeg(yawAndRotation), "deg)");
      }
      this.zoomToolbar.setText(zoom);
      this.canvas.width = this.container.clientWidth * SYSTEM.pixelRatio;
      this.canvas.height = this.container.clientHeight * SYSTEM.pixelRatio;
      var canvasPos = utils_exports.getPosition(this.canvas);
      var canvasW = this.canvas.width;
      var canvasH = this.canvas.height;
      var canvasVirtualCenterX = canvasW / 2 / SYSTEM.pixelRatio;
      var canvasVirtualCenterY = canvasH / 2 / SYSTEM.pixelRatio;
      var context = this.canvas.getContext("2d");
      context.clearRect(0, 0, canvasW, canvasH);
      var mapW = mapImage.width;
      var mapH = mapImage.height;
      context.save();
      context.translate(canvasW / 2, canvasH / 2);
      context.rotate(-yawAndRotation);
      context.scale(zoom, zoom);
      canvasShadow(context, 0, 0, MAP_SHADOW_BLUR);
      drawImageHighDpi(context, mapImage, -center.x - offset.x, -center.y - offset.y, mapW, mapH);
      context.restore();
      [].concat(_toConsumableArray(this.config.hotspots), _toConsumableArray(this.state.markers)).forEach(function (hotspot) {
        var image = _this10.__loadImage(hotspot.image || _this10.config.spotImage);
        var hotspotPos = _objectSpread({}, offset);
        if ("yaw" in hotspot && "distance" in hotspot) {
          var angle = utils_exports.parseAngle(hotspot.yaw) + rotation;
          hotspotPos.x += Math.sin(-angle) * hotspot.distance;
          hotspotPos.y += Math.cos(-angle) * hotspot.distance;
        } else if ("x" in hotspot && "y" in hotspot) {
          hotspotPos.x += center.x - hotspot.x;
          hotspotPos.y += center.y - hotspot.y;
        } else {
          utils_exports.logWarn("Hotspot ".concat(hotspot["id"], " is missing position (yaw+distance or x+y)"));
          return;
        }
        var spotPos = projectPoint(hotspotPos, yawAndRotation, zoom);
        _this10.state.hotspotPos[hotspot.id] = {
          x: canvasVirtualCenterX - spotPos.x + canvasPos.x,
          y: canvasVirtualCenterY - spotPos.y + canvasPos.y
        };
        var x = canvasVirtualCenterX - spotPos.x;
        var y = canvasVirtualCenterY - spotPos.y;
        var size = hotspot.size || _this10.config.spotSize;
        context.save();
        context.translate(x * SYSTEM.pixelRatio, y * SYSTEM.pixelRatio);
        canvasShadow(context, PIN_SHADOW_OFFSET, PIN_SHADOW_OFFSET, PIN_SHADOW_BLUR);
        if (image) {
          drawImageCentered(context, image, size);
        } else {
          context.fillStyle = hotspot.color || _this10.config.spotColor;
          context.beginPath();
          context.arc(0, 0, size * SYSTEM.pixelRatio / 2, 0, 2 * Math.PI);
          context.fill();
        }
        context.restore();
      });
      var pinImage = this.__loadImage(this.config.pinImage);
      if (pinImage) {
        var pinPos = projectPoint(offset, yawAndRotation, zoom);
        var x = canvasVirtualCenterX - pinPos.x;
        var y = canvasVirtualCenterY - pinPos.y;
        var size = this.config.pinSize;
        var angle = this.config["static"] ? yaw + rotation : 0;
        context.save();
        context.translate(x * SYSTEM.pixelRatio, y * SYSTEM.pixelRatio);
        context.rotate(angle);
        canvasShadow(context, PIN_SHADOW_OFFSET, PIN_SHADOW_OFFSET, PIN_SHADOW_BLUR);
        drawImageCentered(context, pinImage, size);
        context.restore();
      }
    }
  }, {
    key: "__move",
    value: function __move(clientX, clientY) {
      var yaw = this.viewer.getPosition().yaw;
      var zoom = Math.exp(this.state.zoom);
      var move = unprojectPoint({
        x: this.state.mouseX - clientX,
        y: this.state.mouseY - clientY
      }, this.config["static"] ? 0 : yaw + this.config.rotation, zoom);
      this.state.offset.x += move.x;
      this.state.offset.y += move.y;
      this.update();
      this.state.mouseX = clientX;
      this.state.mouseY = clientY;
    }
  }, {
    key: "__findHotspot",
    value: function __findHotspot(clientX, clientY) {
      var k = this.config.spotSize / 2;
      var hotspotId = null;
      for (var _i2 = 0, _Object$entries = Object.entries(this.state.hotspotPos); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          id = _Object$entries$_i[0],
          _Object$entries$_i$ = _Object$entries$_i[1],
          x = _Object$entries$_i$.x,
          y = _Object$entries$_i$.y;
        if (clientX > x - k && clientX < x + k && clientY > y - k && clientY < y + k) {
          hotspotId = id;
          break;
        }
      }
      return hotspotId;
    }
  }, {
    key: "__handleHotspots",
    value: function __handleHotspots(clientX, clientY) {
      var hotspotId = this.__findHotspot(clientX, clientY);
      if (this.state.hotspotId !== hotspotId) {
        this.__resetHotspot();
        if (hotspotId) {
          var tooltip;
          if (hotspotId.startsWith(HOTSPOT_MARKER_ID)) {
            var _this$state$markers$f;
            tooltip = (_this$state$markers$f = this.state.markers.find(function (_ref) {
              var id = _ref.id;
              return id === hotspotId;
            })) === null || _this$state$markers$f === void 0 ? void 0 : _this$state$markers$f.tooltip;
          } else {
            var _this$config$hotspots;
            tooltip = (_this$config$hotspots = this.config.hotspots.find(function (_ref2) {
              var id = _ref2.id;
              return id === hotspotId;
            })) === null || _this$config$hotspots === void 0 ? void 0 : _this$config$hotspots.tooltip;
          }
          if (tooltip) {
            var hotspotPos = this.state.hotspotPos[hotspotId];
            var viewerPos = utils_exports.getPosition(this.viewer.container);
            this.state.hotspotTooltip = this.viewer.createTooltip({
              content: tooltip,
              left: hotspotPos.x - viewerPos.x,
              top: hotspotPos.y - viewerPos.y,
              box: {
                width: this.config.spotSize,
                height: this.config.spotSize
              }
            });
          }
        }
        this.state.hotspotId = hotspotId;
      }
    }
  }, {
    key: "__clickHotspot",
    value: function __clickHotspot(clientX, clientY) {
      var hotspotId = this.__findHotspot(clientX, clientY);
      if (hotspotId) {
        this.plugin.dispatchEvent(new _SelectHotspot2(hotspotId));
        if (hotspotId.startsWith(HOTSPOT_MARKER_ID)) {
          var markerId = hotspotId.substring(HOTSPOT_MARKER_ID.length);
          this.viewer.getPlugin("markers").gotoMarker(markerId);
        }
        if (this.maximized) {
          this.toggleMaximized();
        }
      }
      this.__resetHotspot();
    }
  }, {
    key: "__resetHotspot",
    value: function __resetHotspot() {
      var _this$state$hotspotTo;
      (_this$state$hotspotTo = this.state.hotspotTooltip) === null || _this$state$hotspotTo === void 0 ? void 0 : _this$state$hotspotTo.hide();
      this.state.hotspotTooltip = null;
      this.state.hotspotId = null;
    }
  }, {
    key: "__loadImage",
    value: function __loadImage(url) {
      var _this11 = this;
      if (!url) {
        return null;
      }
      if (!this.state.images[url]) {
        var image = loadImage(url);
        this.state.images[url] = {
          loading: true,
          value: image
        };
        image.onload = function () {
          _this11.state.images[url].loading = false;
          _this11.update();
        };
        return null;
      }
      if (this.state.images[url].loading) {
        return null;
      }
      return this.state.images[url].value;
    }
  }]);
  return MapComponent;
}(AbstractComponent);

// src/icons/compass.svg
var compass_default = '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">\n    <defs>\n        <radialGradient id="gradient">\n            <stop offset="80%" stop-color="rgba(255, 255, 255, 0)"/>\n            <stop offset="90%" stop-color="rgba(255, 255, 255, .5)"/>\n        </radialGradient>\n    </defs>\n    <circle cx="250" cy="250" r="250" fill="url(#gradient)"/>\n    <circle cx="250" cy="250" r="245" fill="none" stroke="rgba(255, 255, 255, 0.8)" stroke-width="10"/>\n    <g fill="#222">\n        <path d="M250,0 L265,25 L235,25"/>\n        <rect x="1" y="248" width="18" height="4"/>\n        <rect x="481" y="248" width="18" height="4"/>\n        <rect x="248" y="481" width="4" height="18"/>\n    </g>\n</svg>';

// src/icons/pin.svg
var pin_default = '<svg viewBox="-20 -20 740 740" xmlns="http://www.w3.org/2000/svg">\n    <path d="M350 540a189.4 189.4 0 0 1-189.2-189.1c0-92.4 47.7-143 98.3-225L350-20l90.9 146c50.6 81.9 98.2 132.5 98.2 224.9A189.4 189.4 0 0 1 350 540z" fill="white"/>\n    <circle cx="350" cy="350" r="150" fill="#1E78E6"/>\n</svg>\n';

// src/MapPlugin.ts
var getConfig = utils_exports.getConfigParser({
  imageUrl: null,
  center: null,
  rotation: 0,
  size: "200px",
  position: ["bottom", "left"],
  visibleOnLoad: true,
  compassImage: compass_default,
  pinImage: pin_default,
  pinSize: 35,
  spotColor: "white",
  spotImage: null,
  spotSize: 15,
  "static": false,
  defaultZoom: 100,
  minZoom: 20,
  maxZoom: 200,
  hotspots: []
}, {
  position: function position(_position, _ref3) {
    var defValue = _ref3.defValue;
    return utils_exports.cleanCssPosition(_position, {
      allowCenter: false,
      cssOrder: true
    }) || defValue;
  },
  rotation: function rotation(_rotation) {
    return utils_exports.parseAngle(_rotation);
  },
  defaultZoom: function defaultZoom(_defaultZoom) {
    return Math.log(_defaultZoom / 100);
  },
  maxZoom: function maxZoom(_maxZoom) {
    return Math.log(_maxZoom / 100);
  },
  minZoom: function minZoom(_minZoom) {
    return Math.log(_minZoom / 100);
  }
});
var MapPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(MapPlugin, _AbstractConfigurable);
  var _super8 = _createSuper(MapPlugin);
  function MapPlugin(viewer, config) {
    var _this12;
    _classCallCheck(this, MapPlugin);
    _this12 = _super8.call(this, viewer, config);
    _this12.component = new MapComponent(_this12.viewer, _assertThisInitialized(_this12));
    return _this12;
  }
  _createClass(MapPlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(MapPlugin.prototype), "init", this).call(this);
      this.markers = this.viewer.getPlugin("markers");
      this.viewer.addEventListener(events_exports$1.PositionUpdatedEvent.type, this);
      this.viewer.addEventListener(events_exports$1.SizeUpdatedEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ReadyEvent.type, this, {
        once: true
      });
      this.setHotspots(this.config.hotspots, false);
      if (this.markers) {
        this.markers.addEventListener("set-markers", this);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.PositionUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.SizeUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ReadyEvent.type, this);
      if (this.markers) {
        this.markers.removeEventListener("set-markers", this);
      }
      this.component.destroy();
      delete this.markers;
      _get(_getPrototypeOf(MapPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case events_exports$1.ReadyEvent.type:
          this.show();
          break;
        case events_exports$1.PositionUpdatedEvent.type:
          this.component.update();
          break;
        case events_exports$1.SizeUpdatedEvent.type:
          if (this.component.maximized) {
            this.component.update();
          }
          break;
        case "set-markers":
          this.component.setMarkers(this.__markersToHotspots(e.markers));
          break;
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      _get(_getPrototypeOf(MapPlugin.prototype), "setOptions", this).call(this, options);
      this.component.applyConfig();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.component.hide();
    }
  }, {
    key: "show",
    value: function show() {
      this.component.show();
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.component.collapsed) {
        this.component.toggleCollapse();
      }
    }
  }, {
    key: "open",
    value: function open() {
      if (this.component.collapsed) {
        this.component.toggleCollapse();
      }
    }
  }, {
    key: "minimize",
    value: function minimize() {
      if (this.component.maximized) {
        this.component.toggleMaximized();
      }
    }
  }, {
    key: "maximize",
    value: function maximize() {
      if (!this.component.maximized) {
        this.component.toggleMaximized();
      }
    }
  }, {
    key: "setImage",
    value: function setImage(url, center, rotation) {
      if (!utils_exports.isNil(rotation)) {
        this.config.rotation = utils_exports.parseAngle(rotation);
      }
      if (!utils_exports.isNil(center)) {
        this.config.center = center;
      }
      this.config.imageUrl = url;
      this.component.reload();
    }
  }, {
    key: "setCenter",
    value: function setCenter(center) {
      this.config.center = center;
      this.component.recenter();
    }
  }, {
    key: "setHotspots",
    value: function setHotspots(hotspots) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var ids = [];
      var i = 1;
      hotspots === null || hotspots === void 0 ? void 0 : hotspots.forEach(function (hotspot) {
        if (!hotspot.id) {
          hotspot.id = HOTSPOT_GENERATED_ID + i++;
        } else if (ids.includes(hotspot.id)) {
          utils_exports.logWarn("Duplicated hotspot id \"".concat(hotspot.id));
        } else {
          ids.push(hotspot.id);
        }
      });
      this.config.hotspots = hotspots || [];
      if (render) {
        this.component.update();
      }
    }
  }, {
    key: "clearHotspots",
    value: function clearHotspots() {
      this.setHotspots(null);
    }
  }, {
    key: "__markersToHotspots",
    value: function __markersToHotspots(markers) {
      return markers.filter(function (marker) {
        var _marker$data;
        return (_marker$data = marker.data) === null || _marker$data === void 0 ? void 0 : _marker$data[MARKER_DATA_KEY];
      }).map(function (marker) {
        var _marker$config$toolti;
        var markerData = marker.data[MARKER_DATA_KEY];
        var hotspot = _objectSpread(_objectSpread({}, markerData), {}, {
          id: HOTSPOT_MARKER_ID + marker.id,
          tooltip: (_marker$config$toolti = marker.config.tooltip) === null || _marker$config$toolti === void 0 ? void 0 : _marker$config$toolti.content
        });
        if ("distance" in markerData) {
          hotspot.yaw = marker.state.position.yaw;
        } else if (!("x" in markerData) || !("y" in markerData)) {
          utils_exports.logWarn("Marker ".concat(marker.id, " \"map\" data is missing position (distance or x+y)"));
          return null;
        }
        return hotspot;
      }).filter(function (h) {
        return h;
      });
    }
  }]);
  return MapPlugin;
}(AbstractConfigurablePlugin);
MapPlugin.id = "map";
MapPlugin.configParser = getConfig;
MapPlugin.readonlyOptions = ["imageUrl", "center", "visibleOnLoad", "hotspots", "defaultZoom"];

// src/index.ts
DEFAULTS.lang["map"] = "Map";
DEFAULTS.lang["mapMaximize"] = "Maximize";
DEFAULTS.lang["mapMinimize"] = "Minimize";
DEFAULTS.lang["mapReset"] = "Reset";
export { MapPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
